<template>
  <div class="chart-container-outer"
       :class="chartClass"
       data-aos="zoom-out"
       data-aos-offset="400">
    <div class="chart-container">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChartContainer',
  props: ['chartClass']
};
</script>
